import classNames from 'classnames';

import { isColorBright, resolveColorProperty } from '@gn-audio/jss-components';

import GenericBentoGridButtonComponent, {
  GenericBentoGridButtonProps,
} from 'components/Product/GenericBentoGrid/components/GenericBentoGridButton';
import GenericBentoGridSocialButtonsComponent, {
  GenericBentoGridSocialsProps,
} from 'components/Product/GenericBentoGrid/components/GenericBentoGridSocialButtons';
import GenericBentoGridTextFieldComponent, {
  GenericBentoGridTextProps,
} from 'components/Product/GenericBentoGrid/components/GenericBentoGridTextField';
import { GenericBentoGridItemProps } from 'components/Product/GenericBentoGrid/GenericBentoGrid';

const GenericBentoGridItem = ({
  backgroundColor,
  genericBentoGridItemContent,
}: GenericBentoGridItemProps) => {
  const resolvedBackgroundColor = resolveColorProperty(backgroundColor?.value);
  const isBackgroundColorBright = isColorBright(resolvedBackgroundColor);

  const textColorClass = isBackgroundColorBright ? 'text-black' : 'text-white';

  return (
    <div
      style={{ backgroundColor: resolvedBackgroundColor }}
      className={classNames(
        'flex h-64 w-full flex-col items-center justify-center overflow-hidden rounded-xl p-6',
        textColorClass
      )}
    >
      {genericBentoGridItemContent.map((content) => (
        <>
          {!!(content as GenericBentoGridButtonProps)?.variant && (
            <GenericBentoGridButtonComponent
              variant={(content as GenericBentoGridButtonProps).variant}
              icon={(content as GenericBentoGridButtonProps).icon}
              label={(content as GenericBentoGridButtonProps).label}
              link={(content as GenericBentoGridButtonProps).link}
            />
          )}
          {!!(content as GenericBentoGridSocialsProps)?.buttons && (
            <GenericBentoGridSocialButtonsComponent
              buttons={(content as GenericBentoGridSocialsProps).buttons}
            />
          )}
          {!!(content as GenericBentoGridTextProps)?.text && (
            <GenericBentoGridTextFieldComponent
              isHeading={(content as GenericBentoGridTextProps).isHeading}
              text={(content as GenericBentoGridTextProps).text}
            />
          )}
        </>
      ))}
    </div>
  );
};

export default GenericBentoGridItem;
